import React, {memo} from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './ResponsiveImage.module.scss';
const cx = classNames.bind(styles);

const ResponsiveImage = ({ className, children }) => (
  <div className={cx('image', className)}>
    <div className={cx('responsive')}>
      <div className={cx('container')}>{children}</div>
    </div>
  </div>
);

ResponsiveImage.propTypes = {
  className: string,
  children: node.isRequired,
};

ResponsiveImage.defaultProps = {
  className: null,
};

export default memo(ResponsiveImage);



// WEBPACK FOOTER //
// ./src/components/ResponsiveImage/ResponsiveImage.js